/**
 * Carrying the offer that brought a reader to `/pro/` on to the account page.
 *
 * Every offer of Pro links `/pro/?from=<placement>`, and the lean report
 * counts views of the page by that value. The page's own button leads on to
 * the Subscribe on `/user/account/`, and the report counts visits there by
 * the same parameter. `/pro/` is static and cached for everybody, so Hugo
 * writes the button with `from=pro`, and this swaps in the placement the
 * reader arrived with. A press is then counted under the offer that started
 * the journey, and a reader who came to `/pro/` on their own is counted as
 * `pro`.
 *
 * With the script blocked the link is what the markup says, which is `pro`.
 */

/** The links that lead from `/pro/` to the account page's Subscribe. */
const linkSelector = "a[data-cb-pro-account]";

/** The parameter an offer link names its placement in. */
const placementParameter = "from";

/**
 * What a placement looks like, as `src/analytics/pro-offer.ts` counts one.
 *
 * Anything else typed into the address bar is left where it was rather than
 * carried on, so the account page's log holds the slugs the offer module
 * writes and the page's own `pro`.
 */
const placementPattern = /^[a-z0-9][a-z0-9-]{0,39}$/u;

/**
 * Points the account links on the page at the placement the reader came from.
 * @param document - The page.
 * @param search - The page's own query string, `?from=fuxi-done` or empty.
 */
export function carryOfferPlacement(document: Document, search: string): void {
  const placement = new URLSearchParams(search).get(placementParameter);

  if (placement === null || !placementPattern.test(placement)) {
    return;
  }

  for (const link of document.querySelectorAll<HTMLAnchorElement>(
    linkSelector,
  )) {
    const url = new URL(link.href);

    url.searchParams.set(placementParameter, placement);
    link.setAttribute("href", `${url.pathname}${url.search}${url.hash}`);
  }
}
